var map = {
	"./arrow.svg": 55016,
	"./audio.svg": 64859,
	"./chat.svg": 25954,
	"./close2.svg": 31455,
	"./del.svg": 80886,
	"./delete.svg": 98031,
	"./document.svg": 72834,
	"./document2.svg": 83281,
	"./find.svg": 38910,
	"./important.svg": 73389,
	"./list.svg": 65091,
	"./listen.svg": 27667,
	"./listen1.svg": 47421,
	"./message.svg": 97124,
	"./month.svg": 92356,
	"./monthActive.svg": 12806,
	"./pause.svg": 78026,
	"./pause1.svg": 15571,
	"./pdf.svg": 10082,
	"./photo.svg": 68053,
	"./play.svg": 32283,
	"./play2.svg": 13993,
	"./play3.svg": 27442,
	"./step.svg": 96392,
	"./target.svg": 12751,
	"./top.svg": 32503,
	"./upload.svg": 4129,
	"./uploadDel.svg": 69862,
	"./vedio.svg": 32630,
	"./week.svg": 25616,
	"./weekActive.svg": 21220,
	"./work.svg": 59359,
	"./workDocument.svg": 89719,
	"./workFinish.svg": 18789,
	"./workupload.svg": 52732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42007;